module.exports = __webpack_public_path__ + "img/banner.0cdb12c9.jpg";